import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Carousel 3-Up Video",
    description:
        "Carousel with 3 videos in each slide. (All items MUST be videos).",
};
